// extracted by mini-css-extract-plugin
var _1 = "TagRemoveControl-modulecloseIcon__hGUV1 IconNG-moduleiconContainer__SxWZ0";
export { _1 as "closeIcon" }
